import { render, staticRenderFns } from "./OnboardingDesk.vue?vue&type=template&id=21d2ee6b"
import script from "./OnboardingDesk.vue?vue&type=script&lang=js"
export * from "./OnboardingDesk.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDesk.vue?vue&type=style&index=0&id=21d2ee6b&prod&lang=scss&style=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports